import getDateToday from '../../lib/utils/getCurrentDateFormatted'
import { MorningScanResponse } from '../../types/MorningScanResponse'
import { ScanPayload, ScanResponse } from '../../types/ScanResult'
import { api } from './api'

export const morningScanApi = api.injectEndpoints({
  endpoints: (builder) => ({
    scan: builder.mutation<ScanResponse, ScanPayload>({
      query: (params) => ({
        url: '/delivery/functions/morning-scan',
        method: 'POST',
        body: {
          subcoId: params.subcoId,
          trunkrsNrOrBarcode: params.trunkrsNrOrBarcode,
        },
      }),
      invalidatesTags: ['MorningScanResult'],
    }),
    getMorningScanResult: builder.query<MorningScanResponse, number>({
      query: (params) => ({
        url: '/delivery/functions/shipments/morning-scan/v2',
        params: {
          date: getDateToday(),
          subcoId: params,
        },
      }),
      providesTags: ['MorningScanResult'],
    }),
  }),
})

export const { useGetMorningScanResultQuery, useScanMutation } = morningScanApi
